export default __webpack_public_path__ + "static/14_18-18354f29e9ef897d6dac6b85a9c9125e.png";